// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DollarCircleFilledSvg from "@ant-design/icons-svg/es/asn/DollarCircleFilled";
import AntdIcon from '../components/AntdIcon';

var DollarCircleFilled = function DollarCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DollarCircleFilledSvg
  }));
};

DollarCircleFilled.displayName = 'DollarCircleFilled';
export default React.forwardRef(DollarCircleFilled);